<template>
    <div class="sound-main">
        <el-row>
            <div class="sound-title">
                <!-- <span>{{ currentGame.title }}</span> -->
            </div>
        </el-row>
        <el-row>
            <el-col :span="6">
                <div class="word-title">得分</div>
                <div class="word-title"><span class="game-info-span">{{ getUnitScore() }}</span></div>
            </el-col>
            <el-col :span="12">
                <div class="word-title">难易度<span class="game-info-span"></span></div>
                <div class="word-title"><el-rate v-model="currentGame.difficulty" disabled :max="3"
                        text-color="#ff9900">
                    </el-rate></div>
            </el-col>
            <el-col :span="6">
                <div class="word-title">剩余时间</div>
                <div class="word-title"><span class="game-info-span">{{ seconds }}</span></div>
            </el-col>
        </el-row>
        <el-row>
            <div class="sound-word">
                <span v-if="gameType !== '听力消消乐'">{{ currentGame.title }}</span>
                <i v-else @click="playAudio(currentGame.audioUrlId)" :class="['sound-word-i', iconPlay]"></i>
            </div>
        </el-row>
        <el-row>
            <el-col v-for="(word, index) in currentGame.words" :key="'word' + index" :span="12">
                <div :class="word.selected ? 'sound-word-item-selected' : 'sound-word-item'"
                    @click="handleSelectClick(word, index)">
                    <span>{{ word.word }}</span>
                </div>
            </el-col>
        </el-row>
        <!-- 提示 -->
        <!-- <el-row v-if="seconds === 0 || issubmit === true"> -->
        <el-row>
            <div class="sound-tips">
                <span>游戏结束，您本局得分：</span><span class="sound-tips-score">{{ score }}</span>
            </div>
            <div class="sound-tips-next" v-if="issubmit === true">
                <el-button v-if="unitScore.length === data.length" type="primary" @click="resetGame" size="small"
                    style="width: 80%;">再开一局</el-button>
                <el-button v-else type="success" @click="handleNextClick" size="small"
                    style="width: 80%;">下一局</el-button>
            </div>
            <div class="sound-tips-next" v-else>
                <el-button v-if="unitScore.length === data.length" type="primary" @click="resetGame" size="small"
                    style="width: 80%;">再开一局</el-button>
                <el-button v-else type="success" @click="checkAnswer" :disabled="!isSelected" size="small"
                    style="width: 80%;">提交答案</el-button>
            </div>
        </el-row>

        <!-- 操作按钮 -->
        <el-row class="sound-look">
            <el-col :span="12" class="sound-btn">
                <el-button type="primary" @click="handleClick(false)" size="small">瞄一眼</el-button>
            </el-col>
            <el-col :span="12" class="sound-btn">
                <el-button v-if="limitCount > 0" type="primary" @click="handleClick(true)" size="small">使用道具</el-button>
                <el-button v-else type="primary" disabled size="small">使用道具</el-button>
            </el-col>
        </el-row>
        <el-row>
            <el-dialog width="100%" :visible.sync="dialogVisible" append-to-body :title="tips" center
                :show-close="true">
                <el-row class="sound-look-item" v-for="(row, index) in currentGame.words" :key="'row1' + index">
                    <el-col :span="18">
                        <div class="sound-look-item-left">
                            <i v-if="showAnswer && currentGame.answers.indexOf(row.word) !== -1 || currentGame.answers.indexOf(row.cnWord) !== -1"
                                class="el-icon-check"></i><span style="font-weight: 700;">{{ row.word }}</span>
                            <span>{{ row.cnWord }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="sound-look-item-right"><el-button type="success" @click="handleListenClick(row)"
                                size="mini">听原音</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-dialog>
        </el-row>
    </div>
</template>

<script>
import api from '@/utils/api'
import Enumerable from 'linq'
import _ from 'lodash'
import { Howl } from 'howler'
export default {
    props: {
        gameData: {
            type: Array,
            default: () => [{
                id: 1, title: '', audioUrlId: '', answers: [''], words: [{ word: '', selected: false }], multiSelect: false
            }]
        },
        difficultyList: {
            type: Array,
            default: () => []
        },
        gameType: {
            type: String,
            default: '听力消消乐'
        }
    },
    data () {
        return {
            timer: null,
            seconds: 0,
            difficulty: '简单',
            dialogVisible: false,
            myAudio: null,
            score: 10,
            issubmit: false,
            isSelected: false, // 是否选择了选项
            unitScore: [], // 每局得分
            iconPlay: 'el-icon-video-play',
            showAnswer: false,
            limitCount: 5, // 道具使用次数
            tips: '',
            successAudio: null, // 成功音效
            failAudio: null, // 失败音效
            data: [],
            currentGameIndex: 0,
            currentGame: {
                // id: 1,
                // title: 'Grape',
                // audioUrlId: guid,
                // answers: ['apple'],
                // words: [{ 'word': 'apple', 'selected': false }, { 'word': 'banana', 'selected': false }, { 'word': 'orange', 'selected': false }, { 'word': 'pear', 'selected': false }],
                // multiSelect: false
            }
        }
    },
    created () {
        this.loadSound()
    },
    methods: {
        loadSound () {
            this.$axios.get(api.getSuccessMp3)
                .then(res => {
                    this.successAudio = res.data.result.base64Data
                })
            this.$axios.get(api.getFailedMp3)
                .then(res => {
                    this.failAudio = res.data.result.base64Data
                })
        },
        resetGame () {
            clearInterval(this.timer)
            this.$confirm('已经完成，继续重做?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info',
                center: true
            }).then(() => {
                this.$emit('reload-data')// 通知父组件重新加载数据
            })
        },
        handleClick (showAnswer) {
            this.dialogVisible = true
            this.showAnswer = showAnswer
            this.tips = `道具剩余次数：${this.limitCount}`
            if (showAnswer && this.limitCount > 0) {
                this.limitCount--
            }
            if (showAnswer === false) {
                this.tips = `瞄一眼`
            }
        },
        handleSelectClick (word, index) {
            var _this = this

            // console.log('currentGame：', word)
            _this.currentGame.words.forEach((item, i) => {
                if (i !== index) {
                    _this.$set(_this.currentGame.words[i], 'selected', false)
                } else {
                    _this.$set(_this.currentGame.words[i], 'selected', true)
                }
            })

            _this.isSelected = true
        },
        startGame () {
            var _this = this
            // 初始化参数
            clearInterval(this.timer)
            _this.score = 0
            _this.seconds = _this.setDifficulty()// 重置时间
            _this.playAudio()

            this.timer = setInterval(() => {
                if (_this.seconds > 0) _this.seconds--
                else {
                    clearInterval(this.timer)
                    this.timer = null
                }
            }, 1000)
        },
        playAudio (id, islook) {
            if (this.unitScore.length === this.data.length) {
                clearInterval(this.timer)
                console.log('游戏结束')
                this.$emit('save-answer', this.getUnitScore())// 通知父组件重新加载数据// 自动保存答案
                return
            }

            this.iconPlay = 'el-icon-video-pause'
            if (this.myAudio) {
                this.myAudio.unload()// 释放音频资源
                this.myAudio = null
            }
            if (this.gameType !== '听力消消乐' && !islook) {
                return // 非听力消消乐不需要自动播放
            }
            var wordId = id || this.currentGame.audioUrlId
            this.$axios.post(api.getMp3, { id: wordId })
                .then(res => {
                    var blobUrl = this.base64ToBlobUrl(res.data.result.base64Data)
                    this.myAudio = new Howl({
                        src: [blobUrl],
                        html5: true, // 强制使用HTML5 Audio
                        onend: function () {
                            this.iconPlay = 'el-icon-video-play'
                            // console.log('Finished!')
                        }
                    })
                    this.myAudio.play()
                }).catch(err => {
                    this.iconPlay = 'el-icon-video-play'
                    console.log('Error fetching audio:', err)
                })
        },
        setDifficulty () {
            if (this.difficulty === '简单') {
                return 20
            } else if (this.difficulty === '中等') {
                return 15
            } else {
                return 10
            }
        },
        getUnitScore () {
            return Enumerable.from(this.unitScore).sum(s => s.score)
        },
        checkAnswer () {
            var j = 0
            var yourAnswers = Enumerable.from(this.currentGame.words).where(x => x.selected).select(x => x.word).toArray()
            for (let i = 0; i < this.currentGame.answers.length; i++) {
                if (yourAnswers.indexOf(this.currentGame.answers[i]) > -1) {
                    j++
                }
            }
            // 正确得分10分，错误得分0分
            if (j === this.currentGame.answers.length) {
                this.score = 10
            } else {
                this.score = 0
            }
            // 提交后显示下一局按钮
            this.issubmit = true

            if (Enumerable.from(this.unitScore).where(w => w.id === this.currentGame.id).count() > 0) {
                // 获取索引
                var index = this.getCurrentIndex()
                this.unitScore.splice(index, 1, { id: this.currentGame.id, score: this.score })
            } else {
                this.unitScore.push({ id: this.currentGame.id, score: this.score })
            }
            // 提交答案后，播放提示音
            if (this.score === 10) {
                // 处理正确答案的逻辑
                this.createAudioAndPlay(this.successAudio)
            } else {
                this.createAudioAndPlay(this.failAudio)
            }
            // 保存成绩
            if (this.unitScore.length === this.data.length) {
                console.log('游戏结束')
                clearInterval(this.timer)
                this.$emit('save-answer', this.getUnitScore())// 通知父组件重新加载数据// 自动保存答案
            }
        },
        getCurrentIndex () {
            var index = this.currentGameIndex
            // console.log('当前局索引：', index)
            return index
        },
        createAudioAndPlay (base64) {
            var blobUrl = this.base64ToBlobUrl(base64)
            if (this.myAudio) {
                this.myAudio.unload()// 释放音频资源
                this.myAudio = null
            }
            this.myAudio = new Howl({
                src: [blobUrl],
                html5: true, // 强制使用HTML5 Audio
                onend: function () {
                    // console.log('Finished!')
                }
            })
            this.myAudio.play()
        },
        handleNextClick () {
            var index = this.getCurrentIndex()
            if (index === this.data.length - 1) {
                return
            }
            // console.log('当前局索引：', index)
            this.issubmit = false
            this.currentGame = _.cloneDeep(this.data[index + 1])
            this.currentGameIndex = index + 1
            // console.log('下一局，ID：', this.currentGame)
            this.startGame()// 重新开始计时
        },
        handleListenClick (row) {
            this.playAudio(row.id, true)
        },
        // 将Base64转为Blob URL
        base64ToBlobUrl (base64) {
            const byteString = atob(base64)
            const ab = new ArrayBuffer(byteString.length)
            const ia = new Uint8Array(ab)

            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i)
            }

            const blob = new Blob([ab], { type: 'audio/mpeg' })
            return URL.createObjectURL(blob) // 返回Blob URL
        }
    },
    beforeUnmount () {
        // 组件卸载前清理
        clearInterval(this.timer)
        this.myAudio.unload()// 释放音频资源
        this.myAudio = null
    },
    watch: {
        gameData: {
            deep: true,
            immediate: true,
            handler (newVal) {
                if (Array.isArray(newVal) && newVal.length > 0) {
                    // 复制一份，避免直接修改父组件数据
                    console.log('gameData changed:', newVal)
                    this.currentGame = _.cloneDeep(newVal[0])
                    this.seconds = this.setDifficulty()
                    this.score = 0
                    this.issubmit = false
                    this.isSelected = false
                    this.unitScore = []
                    this.currentGameIndex = 0
                    this.data = _.cloneDeep(newVal)
                    this.startGame()
                }
            }
        }
    }
}
</script>

<style scoped lang="less">
.sound-main {
    background-color: #fff;
    border-radius: 5px;
    margin-top: 20px;
    padding-top: 20px;
}

.sound-difficulty {
    float: right;
    margin: 0 10px;
    padding: 0 10px;
}

.sound-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    margin: 0px;
    padding: 10px;
}

.sound-score-span-des {
    font-size: 16px;
    padding: 10px;
    margin: 10px 0px 10px 10px;
    text-align: center;
    display: inline-block;
    min-width: 15px;
}

.sound-score-span {
    padding: 10px 0;
    font-size: 16px;
    font-weight: bold;
    display: inline-block;
    min-width: 15px;
}

.sound-word,
.sound-word-item,
.sound-word-item-selected {
    margin: 0 auto;
    margin: 10px;
    padding: 8px;
    width: 75%;
    background-color: #3498db;
    text-align: center;
    border-radius: 5px;
}

.sound-word {
    margin: 10px auto;
    color: #fff;
    font-size: 20px;
}

.sound-word-i {
    margin-left: 10px;
    font-size: 25px;
    color: #fff;
}

.sound-word-item {
    background-color: #f8f9fa;
}

.sound-word-item-selected {
    background-color: #67C23A;
    color: #fff;
}

.sound-tips {
    width: 80%;
    margin: 10px;
    padding: 10px;
    text-align: center;
}

.sound-tips-score {
    color: red;
    font-weight: 700;
}

.sound-tips-next {
    text-align: center;
}

.sound-btn {
    text-align: center;
    margin: 20px 0;
}

.sound-look {
    width: 80%;
    margin: 0 auto;
}

.sound-look-item {
    margin: 5px;
    padding: 10px;
    background-color: #f8f9fa;
    border-radius: 5px;
}

.sound-look-item-right {
    text-align: right;
    padding-right: 5px;
}

.sound-look-item-left {
    height: 30px;
    line-height: 30px;
}

.sound-look-item-left span {
    padding: 0 10px;
}

.sound-look-item-left i {
    color: #67C23A;
    font-weight: 700;
}

.word-title {
    text-align: center;
    font-size: 15px;
    margin: 0px;
    padding: 5px 0px;
}

.game-info-span {
    font-size: 18px;
    font-weight: bold;
    margin-left: 8px;
    text-align: center;
    color: #3b82f6;
}
</style>



// WEBPACK FOOTER //
// src/components/game/soundtemplete.vue